module.exports = __webpack_public_path__ + "static/media/search.ab2bcd41.svg";